import { Box, Tooltip } from '@mui/material';
import { formatTranslation } from 'intl';
import { ReportTranslationKeys } from 'intl/keys';
import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import { chipSx } from './styles';

type IssueCardChipValue =
  | string
  | { color: string; value: string; textColor?: string; border?: string };

interface IssueCardChipProps {
  values: IssueCardChipValue[];
}

const IssueCardChip = ({ values }: IssueCardChipProps): ReactElement => {
  const intl = useIntl();
  return (
    <Tooltip title={formatTranslation(intl, ReportTranslationKeys.issueNumberLabel)}>
      <Box>
        {values.map((val) =>
          typeof val === 'string' ? (
            <Box key={val} sx={chipSx}>
              {val}
            </Box>
          ) : (
            <Box
              key={val.value}
              sx={chipSx}
              style={{
                backgroundColor: val.color,
                color: val.textColor || 'white',
                border: val.border || 'none',
              }}
            >
              {val.value}
            </Box>
          )
        )}
      </Box>
    </Tooltip>
  );
};

export const MemoIssueCardChip = React.memo(IssueCardChip);
